import axios from "axios";
import { logout } from "../redux/actions/Auth/auth.actions";
import store from "../redux/store";

import history from "../hooks/history";

// dev;
// export const Domain = "http://192.168.18.9:8080";
// export const API = "http://192.168.18.9:8080/api";

// staging
// export const Domain =
//   "https://wave-cards-q7rv43fvq-farrukhneslit-gmailcom.vercel.app";
// export const API =
//   "https://wave-cards-q7rv43fvq-farrukhneslit-gmailcom.vercel.app/api";

export const Domain =
  process.env.REACT_APP_URL || "https://api.wavecodes.com.au";
export const API =
  process.env.REACT_APP_API_URL || "https://api.wavecodes.com.au/api";

export const request = axios.create({
  baseURL: API,
  // timeout: 2000,
});
const ResponseInterceptor = (response) => {
  return response;
};
const RequestInterceptor = async (config) => {
  if (config && config.headers) {
    // config.headers.common['authorization'] = `Bearer ${token}`
    const user = JSON.parse(localStorage.getItem("user"));
    config.headers = { ...{ Authorization: user } };
  }
  return config;
};
request.interceptors.request.use(RequestInterceptor);
request.interceptors.response.use(ResponseInterceptor, (error) => {
  console.log("requested url => ", error?.response?.request?.responseURL);
  // const responseError = error?.response?.data.data;
  console.log("high order error=>", error?.response?.data?.data);
  if (error?.response?.data) {
    switch (error?.response?.data?.data) {
      case "Deactivated by admin":
        return Promise.reject("Deactivated by admin");
      case "You account has been deactivated by admin !":
        sessionExpired();
        return Promise.reject("You account has been deactivated by admin !");
      case "You account has been deactivated by super admin !":
        sessionExpired();
        return Promise.reject(
          "You account has been deactivated by super admin !"
        );

      default: {
        if (
          error.response.data === "Unauthorized" &&
          error.response.status === 401
        ) {
          error.response.data = {
            data: "Unauthorized",
          };

          sessionExpired();
          return Promise.reject(
            "Your session has expired, please log in again!"
          );
        }

        return Promise.reject(error);
      }
    }
  } else if (error.request) {
    if (error.request._timedOut) {
      return Promise.reject("The request timed out.");
    }
    if (error?.request?._response.includes("Failed to connect to")) {
      return Promise.reject("Opps seems like you're offline.");
    }

    return Promise.reject(error?.request?._response);
  } else {
    return Promise.reject(error.request);
  }
});
const sessionExpired = () => {
  store.dispatch(logout());
  history.push("/login");
};
